module.exports = __webpack_public_path__ + "media/images/buoy-2x-53017384a3104a3873fae35419c794ed.png";